// ==================== UpcomingLeaves.jsx ====================
import React, { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import "../Styling/UpcomingLeaves.css";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
import PastLeavesModal from "./PastLeavesModal";

const UpcomingLeaves = () => {
  const { user } = useAuth();

  const userId = user?.userId;
  const organisationId = user?.organisationId;

  const [showPastModal, setShowPastModal] = useState(false);
  const [upcomingLeaves, setUpcomingLeaves] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId || !organisationId) return;

    const fetchUpcomingLeaves = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          `${Base_URL}/Leave/GetLeavesDataPersonal?userId=${userId}&orgId=${organisationId}`
        );

        const result = await response.json();

        if (response.ok) {

          const today = new Date();

          const filteredLeaves = (result.data || []).filter(
            (leave) =>
              new Date(
                leave.startDate || leave.leaveStartDate
              ) >= today
          );

          setUpcomingLeaves(filteredLeaves);

        } else {
          setUpcomingLeaves([]);
        }

      } catch (error) {
        console.error("Error fetching upcoming leaves:", error);
        setUpcomingLeaves([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUpcomingLeaves();

  }, [userId, organisationId]);

  const formatDateRange = (start, end) => {

    if (!start) return "-";

    const options = {
      month: "short",
      day: "numeric"
    };

    const startDate =
      new Date(start).toLocaleDateString(
        "en-US",
        options
      );

    if (!end || start === end)
      return startDate;

    const endDate =
      new Date(end).toLocaleDateString(
        "en-US",
        options
      );

    return `${startDate}–${endDate}`;
  };

  return (
    <>
      {/* Past Leaves Modal */}
      {showPastModal && (
        <PastLeavesModal
          userId={userId}
          organisationId={organisationId}
          onClose={() => setShowPastModal(false)}
        />
      )}

      <div className="upcomingleaves-card compact">

        {/* Header */}
        <div className="upcomingleaves-header compact">

          <div className="upcomingleaves-icon small">
            <CalendarDays size={18} />
          </div>

          <h4>Leaves</h4>

          <span
            className="header-badge clickable"
            onClick={() => setShowPastModal(true)}
          >
            View Past Leaves
          </span>

        </div>

        {/* Content */}
        <div className="upcomingleaves-list compact">

          {loading ? (

            <div className="upcomingleaves-empty">
              Loading...
            </div>

          ) : upcomingLeaves.length > 0 ? (

            upcomingLeaves.map((leave, idx) => {

              const status =
                leave.status ||
                leave.leaveStatus ||
                leave.approvalStatus ||
                "";

              return (
                <div
                  key={idx}
                  className="upcomingleaves-row"
                >

                  <span className="leave-type-chip">
                    {
                      leave.leaveType ||
                      leave.Description
                    }
                  </span>

                  <span className="leave-dates">
                    {formatDateRange(
                      leave.startDate || leave.leaveStartDate,
                      leave.endDate || leave.leaveEndDate
                    )}
                  </span>

                  <span className="leave-days">
                    {
                      leave.days ||
                      leave.leaveDuration ||
                      0
                    }d
                  </span>

                  <span
                    className={`leave-status ${status
                      .toLowerCase()
                      .replace(/\s+/g, "")}`}
                  >
                    {status}
                  </span>

                </div>
              );
            })

          ) : (

            <div className="upcomingleaves-empty">
              No upcoming leaves
            </div>

          )}

        </div>
      </div>
    </>
  );
};

export default UpcomingLeaves;